import createLucideIcon from '../createLucideIcon';

const Check = createLucideIcon('CheckIcon', [['path', { d: 'M20 6 9 17l-5-5', key: '1gmf2c' }]]);

export default Check;
